import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppMaterialModule } from "src/app/app.material.module";
import { AuthService } from "src/app/services/auth.service";
import { FilterService } from "src/app/services/filter.service";
import { ImagePrintService } from "src/app/services/image-print.service";
import { MedicalOrderService } from "src/app/services/medical-order.service";
import { SharedModule } from "../shared.module";
import { MedicalOrderScannControlComponent } from "./medical-order-scann/medical-order-scann-control.component";
import { MedicalAppointmentReappointmentControlComponent } from './medical-appointment-reappointment/medical-appointment-reappointment-control.component';
import { TransactionReferenceComponent } from './transaction-reference/transaction-reference.component';

@NgModule({
  declarations: [
    MedicalOrderScannControlComponent,
    MedicalAppointmentReappointmentControlComponent,
  ],
  providers: [
    MedicalOrderService,
    ImagePrintService,
    FilterService,
    AuthService,
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [
    MedicalOrderScannControlComponent,
    MedicalAppointmentReappointmentControlComponent
  ]
})
export class ControlsModule {}
